import React, {Fragment, useState} from 'react'
import {Outlet, Link} from 'react-router-dom';


function Navigation() {
    const [active, setActive] = useState(false);
    const [activeClass, setActiveClass] = useState("active");
    // for search model 
    const [display, setdisplay] = useState("none");

 
  
  return (
    <Fragment>
        <div
        className={
          active ? "offcanvas-menu-overlay active" : "offcanvas-menu-overlay"
        }
      ></div>
      <div
        className={
          active ? "offcanvas-menu-wrapper active" : "offcanvas-menu-wrapper"
        }
      >
        <div
          className="offcanvas__close"
          onClick={() => {
            setActive(false);
          }}
        >
          +
        </div>
        <ul className="offcanvas__widget">
          <li>
            <span className="icon_search search-switch" 
            onClick={()=>{setdisplay('block')}}></span>
          </li>
          <li>
            <Link to="favourite">
              <span className="icon_heart_alt"></span>
              <div className="tip">100</div>
            </Link>
          </li>
          <li>
            <Link to="cart">
              <span className="icon_bag_alt"></span>
              <div className="tip">2</div>
            </Link>
          </li>
        </ul>
        <div className="offcanvas__logo">
          <Link to="#">
            <h2>Apna hai</h2>
            <img src="" alt="" />
          </Link>
        </div>
        <div id="mobile-menu-wrap"></div>
        <div className="offcanvas__auth pb-3 font-weight-normal">
        <Link to="#">Home</Link>
        </div>
        <div className="offcanvas__auth pb-3 font-weight-normal">
        <Link to="women">Women’s</Link>
        </div>
        <div className="offcanvas__auth pb-3 font-weight-normal">
        <Link to="men">Men’s</Link>
        </div>
        <div className="offcanvas__auth pb-3 font-weight-normal">
        <Link to="shop">Shop</Link>
        </div>
        <div className="offcanvas__auth pb-3 font-weight-normal">
        <Link to="blog">Blog</Link>
        </div>
        <div className="offcanvas__auth pb-3 font-weight-normal">
        <Link to="contact">Contact</Link>
        </div>
        <div className="offcanvas__auth pb-3 font-weight-normal">
          <Link to="login">Login/Register</Link>
        </div>
      </div>
      {/* <!-- Offcanvas Menu End --> */}

      {/* <!-- Header Section Begin --> */}
      <header className="header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-3 col-lg-2">
              <div className="header__logo">
                <Link to="/">
                  <h2>Apna hai</h2>
                  <img src="" alt="" />
                </Link>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7">
              <nav className="header__menu">
                <ul>
                  <li className={activeClass === "active" || activeClass === "1" ? 'active' : null} onClick={() => setActiveClass("1")}>
                    <Link to="./">Home</Link>
                  </li>
                  <li className={activeClass === "2" ? 'active' : null} onClick={() => setActiveClass("2")}>
                    <Link to="women">Women’s</Link>
                  </li>
                  <li className={activeClass  === "3" ? 'active' : null} onClick={() => setActiveClass("3")}>
                    <Link to="men">Men’s</Link>
                  </li>
                  <li className={activeClass  === "4" ? 'active' : null} onClick={() => setActiveClass("4")}>
                    <Link to="shop">Shop</Link>
                  </li>
                  {/* <li>
                    <Link to="#">Pages</Link>
                    <ul className="dropdown">
                      <li>
                        <Link to="./product-details.html">Product Details</Link>
                      </li>
                      <li>
                        <Link to="./shop-cart.html">Shop Cart</Link>
                      </li>
                      <li>
                        <Link to="./checkout.html">Checkout</Link>
                      </li>
                      <li>
                        <Link to="./blog-details.html">Blog Details</Link>
                      </li>
                    </ul>
                  </li> */}
                  <li className={activeClass  === "5" ? 'active' : null} onClick={() => setActiveClass("5")}>
                    <Link to="blog">Blog</Link>
                  </li>
                  <li className={activeClass  === "6" ? 'active' : null} onClick={() => setActiveClass("6")} >
                    <Link to="contact">Contact</Link>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="col-lg-3">
              <div className="header__right">
                <div className="header__right__auth">
                  <Link to="login">Login/Register</Link>
                </div>
                <ul className="header__right__widget">
                  <li>
                    <span className="icon_search search-switch"
                    onClick={()=>{setdisplay('block')}}></span>
                  </li>
                  <li>
                    <Link to="favourite">
                      <span className="icon_heart_alt"></span>
                      <div className="tip">2</div>
                    </Link>
                  </li>
                  <li>
                    <Link to="cart">
                      <span className="icon_bag_alt"></span>
                      <div className="tip">2</div>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="canvas__open" onClick={() => setActive(!active)}>
            <i className="fa fa-bars"></i>
          </div>
        </div>
      </header>
      <Outlet/>

 {/* <!-- Search Begin --> */}
 <div className="search-model" style={{ display: `${display}` }}>
        <div className="h-100 d-flex align-items-center justify-content-center">
          <div className="search-close-switch" onClick={()=>{setdisplay('none')}}>+</div>
          <form className="search-model-form">
            <input
              type="text"
              id="search-input"
              placeholder="Search here....."
            />
          </form>
        </div>
      </div>
      {/* <!-- Search End --> */}
        </Fragment>
  )
}

export default Navigation